module.exports = kolibriGlobal.coreVue.components.KExternalLink;